/**
 * Safely decode URI components, handling malformed percent-encoded sequences
 * @param {string} str - The string to decode
 * @returns {string} - The decoded string, or original if decoding fails
 */
export const safeDecodeURIComponent = (str) => {
  try {
    return decodeURIComponent(str)
  } catch (error) {
    console.warn(
      'Failed to decode URI component, using original string:',
      error.message,
    )
    return str
  }
}
